import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {MsalGuard} from '@azure/msal-angular';
import {AUTHENTICATION} from '@infrastructure/http/authentication/authentication';
import {firstValueFrom} from 'rxjs';

export const canActivateViaAuthGuard = async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Promise<boolean> => {
  const authentication = inject(AUTHENTICATION);
  const router = inject(Router);
  const msalGuard = inject(MsalGuard);

  let result = false;

  if (authentication.getCurrentSubscription() && (await firstValueFrom(msalGuard.canActivate(activatedRouteSnapshot, routerStateSnapshot)))) {
    result = true;
  } else {
    router.navigate([RouteUtils.paths.login.absolutePath]);
  }
  return result;
};
